/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/SyncPatientMatchingCard/Phone/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let cardPatientPhoneValueData = fromData.useDataFormat({ viewPath,
context: 'card',
path: 'patient.phone',
format: fromFormat.phoneNumberUS,
})
let constantData = 'No phone'
let aggregateData = fromAggregate.any(cardPatientPhoneValueData, constantData)
let cardMatchPhoneValueData = fromData.useDataValue({ viewPath,
context: 'card',
path: 'match.phone',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtColorsRed900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.900'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginLeft={dtSpaceXxs}
 color={!cardMatchPhoneValueData ? dtColorsRed900 : dtColorsNeutral900}
 size="small"
 data="card.patient.phone"
 format="/Data/format.js phoneNumberUS"
 data="'No phone'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
 data="card.match.phone"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral400}
 text="•"
/>
</div>
{children}
</React.Fragment>)
}